module.exports = __webpack_public_path__ + "img/ai.4f4e61b3.png";